import { Menu } from 'antd';
import styled from 'styled-components';
import CustomImage from './CustomImage';
import Text from './Text';
import { useHistory, useLocation } from 'react-router-dom';
import menuIcons from '../assets/icons/icon-menu-icons.svg';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { menuChange } from '../store/slice/menusSlice';

const { SubMenu, ItemGroup, Item } = Menu;

const CustomMenu = styled(Menu)`
  background-color: #3f4957;
  border-right: 0;
  height: 100%;

  li.ant-menu-item-selected {
    background-color: #4d5868 !important;
    box-shadow: inset 4px 0 0 0 #fff;
  }

  li:first-child {
    margin-top: 7px !important;
    margin-bottom: 12px !important;
  }

  li.menu-last-child {
    box-shadow: none;
  }

  li.ant-menu-item:active,
  .ant-menu-submenu-title:active {
    background: none;
  }
`;

const CustomItem = styled(Item)`
  padding: 0 !important;
  margin: 0 !important;

  :hover,
  :active {
    color: #ffffff !important;
  }
`;

const CustomItemGroup = styled(ItemGroup)(
  ({ color, marginTop = 0 }) => `
  .ant-menu-item-group-title{
    font-family: EdenredMedium, sans-serif;
    color: ${color};
    margin-top: ${marginTop}px;
    padding: 12px 36px 12px 36px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    font-size: 14px;
    letter-spacing: normal;
  }
`,
);

const MenuItemText = styled.div`
  margin: 0 36px;
  box-shadow: inset 0px -1px 0 0 #4d5868;
  display: flex;
  white-space: initial;
  height: 48px;
  align-items: center;

  img {
    width: 20px;
    height: 20px;
  }

  span {
    font-family: UbuntuMedium, sans-serif;
    padding-left: 12px;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #d5d8de;
  }
`;

const CustomSubMenu = styled(SubMenu)`
  // height: 48px;
  .ant-menu-sub.ant-menu-inline {
    background: #fff !important;
  }

  .ant-menu-submenu-title {
    margin-top: 0 !important;
    padding: 0 !important;
    margin-bottom: 0 !important;

    :hover,
    :active,
    :hover > .ant-menu-submenu-arrow,
    :active > .ant-menu-submenu-arrow {
      color: #303845 !important;
    }
  }

  .ant-menu-submenu-expand-icon,
  .ant-menu-submenu-arrow {
    color: #303845;
    width: 4px;
    height: 8px;
  }

  :hover,
  :active {
    color: #ffffff !important;
  }

  .ant-menu-submenu-arrow {
    right: 46px !important;
  }

  .ant-menu-sub > li:first-child {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .ant-menu-inline .ant-menu-item,
  .ant-menu-inline .ant-menu-submenu-title {
    width: 100% !important;
  }
`;

const MenuSubItemText = styled.div`
  margin: 0 0 0 66px;
  box-shadow: none;
  display: flex;
  white-space: initial;
  height: 48px;
  align-items: center;

  img {
    width: 20px;
    height: 20px;
  }

  .sub-menu-text-dot {
    width: 4px;
    height: 4px;
    margin: 10px 8px 10px 0;
    background-color: #3f4957;
    border-radius: 50%;
  }

  span {
    font-family: UbuntuMedium, sans-serif;
    //padding-left: 12px;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #3c4655;
  }
`;

const Menus = ({ setCollapsed = () => {} }) => {
  const history = useHistory();
  const location = useLocation();
  const { selectedKey, menus } = useSelector((state) => state?.menus);
  const dispatch = useDispatch();
  const [topMenu, setTopMenu] = useState([]);
  const [ticketCarMenu, setTicketCarMenu] = useState([]);

  useLayoutEffect(() => {
    if (['/', '/dashboard', '/profile'].includes(location.pathname)) {
      dispatch(menuChange(['']));
    }
  }, [dispatch, location]);

  useEffect(() => {
    if (menus?.length > 0) {
      let fArr = [];
      menus.map((item) =>
        item?.userSubMenus?.map((sub, index) => {
          if (sub?.key?.includes('ticket-car')) {
            fArr.push(sub);
          }
        }),
      );

      let topM = [];
      menus.filter((menu) => {
        const newMenu = menu.userSubMenus.filter((sub) => !sub?.key?.includes('ticket-car'));
        let tempMenu = { ...menu };
        tempMenu.userSubMenus = newMenu;
        topM.push(tempMenu);
      });
      setTopMenu(topM);
      setTicketCarMenu(fArr);
    }
  }, [menus]);

  const handleClick = (e) => {
    dispatch(menuChange?.(e?.key));
    history.push(e?.key);
    setCollapsed(false);
  };

  return (
    <CustomMenu onClick={handleClick} mode="vertical" selectedKeys={selectedKey}>
      {topMenu?.map((menu) => {
        return (
          <>
            <CustomItemGroup title={<Text t={menu?.text} />} color="#ffffff" />
            {menu?.userSubMenus?.map((subMenu) => {
              if (subMenu?.isParent) {
                return (
                  <CustomSubMenu
                    key={subMenu?.key}
                    title={
                      <MenuItemText>
                        <span>
                          <Text t={subMenu?.text} />
                        </span>
                      </MenuItemText>
                    }
                  >
                    {subMenu?.userSubMenus?.map((subSubMenu) => {
                      return (
                        <CustomItem key={subSubMenu?.key}>
                          <MenuSubItemText>
                            <span>
                              <Text t={subSubMenu?.text} />
                            </span>
                          </MenuSubItemText>
                        </CustomItem>
                      );
                    })}
                  </CustomSubMenu>
                );
              } else {
                return (
                  <CustomItem key={subMenu?.key}>
                    <MenuItemText>
                      <CustomImage src={menuIcons} />
                      <span>
                        <Text t={subMenu?.text} />
                      </span>
                    </MenuItemText>
                  </CustomItem>
                );
              }
            })}
          </>
        );
      })}
      {ticketCarMenu?.length > 0 && (
        <>
          <CustomItemGroup title={<Text t={'TICKET CAR'} />} marginTop={10} color="#ffffff" />
          {ticketCarMenu?.map((subMenu) => {
            return (
              <CustomItem key={subMenu?.key}>
                <MenuItemText>
                  <CustomImage src={menuIcons} />
                  <span>
                    <Text t={subMenu?.text} />
                  </span>
                </MenuItemText>
              </CustomItem>
            );
          })}
        </>
      )}
    </CustomMenu>
  );
};

export default Menus;
